import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import sharedStyles from '../../EarningsInsightWidget.module.scss';

export type EarningsInsightEmptyStateVariant =
  | 'preview-unavailable'
  | 'recap-unavailable'
  | 'recap-being-analyzed';

export interface EarningsInsightEmptyStateProps {
  className?: string;
  variant: EarningsInsightEmptyStateVariant;
  fiscalPeriod?: string;
  fiscalYear?: number;
  unsetMinHeight?: boolean;
}

export const EarningsInsightEmptyState = ({
  className,
  variant,
  fiscalPeriod,
  fiscalYear,
  unsetMinHeight = false,
}: EarningsInsightEmptyStateProps) => {
  const { t } = useTranslation(['earnings']);

  const mapVariantToTitle = {
    'preview-unavailable': t(
      'earnings:earningsInsight.drawer.earningsPreview.emptyTitle'
    ),
    'recap-being-analyzed': t(
      'earnings:earningsInsight.drawer.earningsRecap.earningsAreBeingAnalyzedOnQuarterYear',
      { fiscalPeriod, year: fiscalYear }
    ),
    'recap-unavailable': t(
      'earnings:earningsInsight.drawer.earningsRecap.emptyTitle'
    ),
  };

  const isCompact = variant === 'recap-being-analyzed';

  const content = (
    <div className={sharedStyles.emptyWrapper}>
      <img
        className={sharedStyles.emptyImage}
        alt=""
        src="/app/static/images/empty-state/radio-telescope.png"
        height={130}
        width={146}
      />
      <div className={sharedStyles.emptyTitle}>
        {mapVariantToTitle[variant]}
      </div>
    </div>
  );

  if (isCompact) {
    return content;
  }

  return (
    <div
      className={clsx(sharedStyles.emptyContainer, className, {
        [sharedStyles.emptyContainerUnsetMinHeight]: unsetMinHeight,
      })}
    >
      {content}
    </div>
  );
};
